import React from 'react'
import { PodcastEditorContext } from './podcast-editor-context'

export function usePodcastEditor() {
  const ctx = React.useContext(PodcastEditorContext)
  if (!ctx) throw new Error('usePodcastEditor must be used within PodcastEditorProvider')
  return ctx
}
